import{createSidecarMedium as e}from"../../../use-sidecar/dist/es2015/medium.js";var r=e();export{r as effectCar};
